export interface FAQItem {
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    question: '琪琪影院需要注册才能观看吗？',
    answer: '不需要注册！琪琪影院所有高清影视资源均可免费在线观看，无需注册账号，无需下载任何软件，打开网站即可享受流畅的观影体验。',
  },
  {
    question: '为什么琪琪影院的视频不缓冲、不卡顿？',
    answer: '琪琪影院采用先进的P2P-CDN混合加速技术和智能码率自适应算法，根据您的网络环境实时优化视频传输，确保蓝光画质下依然流畅播放，真正做到不缓冲、不卡顿。',
  },
  {
    question: '琪琪影院支持哪些设备观看？',
    answer: '琪琪影院全面支持电脑、平板、手机等各类设备。无论是Windows、Mac、iOS还是Android系统，都可以通过浏览器直接访问观看，无需安装任何APP。',
  },
  {
    question: '琪琪影院的视频画质如何？',
    answer: '我们提供从标清到蓝光的多档画质选择，大部分影片支持1080P全高清和4K超清画质。系统会根据您的网络状况自动推荐最佳画质，您也可以手动切换。',
  },
  {
    question: '琪琪影院的影视资源多久更新一次？',
    answer: '琪琪影院的资源库每日更新，院线新片下映后最快7天内上线，热门电视剧同步跟播。我们的内容团队全天候关注全球影视动态，确保您第一时间看到想看的影片。',
  },
  {
    question: '在琪琪影院观看影视需要付费吗？',
    answer: '完全免费！琪琪影院坚持"免费高清影视"的理念，所有影片均可免费观看，无隐藏收费，无VIP会员制度。我们通过广告收入维持运营，为用户提供永久的免费观影服务。',
  },
];

export const aboutContent = {
  brandIntro: {
    title: '品牌介绍',
    paragraphs: [
      '琪琪影院成立于2020年，是国内领先的高清影视在线观看平台。我们致力于为广大影视爱好者提供海量优质的影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，满足不同用户的多元化观影需求。',
      '经过多年的技术积累和内容建设，琪琪影院已经发展成为拥有百万级日活用户的影视平台。我们的核心技术团队来自一线互联网企业，在视频编解码、CDN加速、智能推荐等领域拥有深厚的技术沉淀。',
      '琪琪影院的使命是"让每个人都能轻松享受高清影视"。我们持续优化播放体验，引入先进的P2P传输技术和智能码率调节系统，确保用户在任何网络环境下都能获得流畅、清晰的观影体验。同时，我们也在不断丰富内容库，与国内外多家内容提供商建立了深度合作关系。',
    ],
    values: [
      { title: '免费观影', desc: '坚持免费模式，让好内容触手可及' },
      { title: '高清画质', desc: '支持蓝光4K超清，极致视觉享受' },
      { title: '流畅体验', desc: '智能加速技术，告别缓冲卡顿' },
      { title: '海量资源', desc: '覆盖全品类，每日更新不停歇' },
    ],
  },
  reputation: {
    title: '口碑评价',
    stats: [
      { label: '日均活跃用户', value: '120万+' },
      { label: '影视资源总量', value: '10万+' },
      { label: '用户好评率', value: '98.5%' },
      { label: '合作内容方', value: '200+' },
    ],
    reviews: [
      {
        name: '电影爱好者小王',
        rating: 5,
        content: '用了琪琪影院两年多了，画质清晰不卡顿，资源更新也很快。最重要的是完全免费，真的是良心平台！强烈推荐给所有喜欢看电影的朋友。',
      },
      {
        name: '追剧达人小李',
        rating: 5,
        content: '作为一个重度追剧患者，琪琪影院简直是我的救星。热门电视剧同步更新，画质还支持蓝光，躺在床上用手机看体验超棒！',
      },
      {
        name: '影视博主老张',
        rating: 5,
        content: '作为影视行业的从业者，我对画质和流畅度要求很高。琪琪影院在这方面做得非常出色，蓝光画质的码率控制得很好，播放体验堪称一流。',
      },
    ],
  },
  contact: {
    title: '联系我们',
    email: 'contact@qiqicinema.com',
    wechat: 'qiqicinema2026',
    qq: '800123456',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};